import { HotelHeaderInfo } from './../store/general/state';
import { IRequest } from './request';

export interface IGeneralData {
    id: number;
    headerType?: string;
    footerType?: string;
    isLoading?: boolean;
    sortByOption: SortByOptions;
    lastRequestAsked: IRequest;
    hotelHeaderInfo?: HotelHeaderInfo;
    isBookingActionEnabled?: boolean;
    user?;
    unreadMessages?;
    loginModalOpened?: boolean;
    bookNowBtnClicked?: boolean;
    isRequestSendEnabled?: boolean;
}

export enum SortByOptions {
    SORT_BY_PRICE_ASC = 'Sort By Price Asc',
    SORT_BY_PRICE_DESC = 'Sort By Price Desc',
    SORT_BY_STARS = 'Sort By Stars',
    SORT_BY_HOTEL_TYPE = 'Sort By Hotel Type',
    SORT_BY_MEAL_TYPE = 'Sort By Meal Type',
    SORT_BY_EXCLUSIVE_CAT = 'Sort By Exclusive Category',
    SORT_BY_OPTIONAL_CAT = 'Sort By Optional Category',
    SORT_BY_EXPERIENCE = 'Sort By Experiences',
    SORT_BY_PRICE = 'Sort By Price',
}
